import { generateURLRappiServices } from 'business/shared/infra';
import urls from 'constants/Urls';

import HttpService from 'services/HttpService';
import type { HasAutoacceptData } from 'shared/infra';
import type { StoreSettingResponse } from '../core/responses';

const _storageItemNames = {
  autoAccept: 'has_auto_accept',
};

function getStoreSettings() {
  const endpointUrl = generateURLRappiServices({
    url: urls.GET_SETTINGS,
  });

  return HttpService.get<StoreSettingResponse>(endpointUrl);
}

function setAutoAcceptStored(data: HasAutoacceptData) {
  localStorage.setItem(_storageItemNames.autoAccept, JSON.stringify(data));
}

function getAutoAcceptStored(): HasAutoacceptData | null {
  const data = localStorage.getItem(_storageItemNames.autoAccept);
  if (!data) {
    return null;
  }
  return JSON.parse(data);
}

export const autoAcceptRepository = {
  getStoreSettings,
  getAutoAcceptStored,
  setAutoAcceptStored,
} as const;
